import React from 'react';
import { oddToStringCheckbet } from '../../data/utils';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, useWidgetContext, WidgetContext } from '../../data/widgets/WidgetContext';
import { getLabel } from '../../InitData';
import BetGeniusWidget from '../widgets/BetGeniusWidget';
import FlashbetWidget from '../widgets/FlashbetWidget';
import StatsCoreWidget from '../widgets/StatsCoreWidget';
import EventInfo from './EventInfo';

const getEsitoClass = function(eventStatus, winning, winningDrawCode) {
	if(eventStatus === 'voided'){
   		return 'esito-vd';
   	}
	if (!['winning', 'losing'].includes(eventStatus) || !winningDrawCode) {
	    return 'esito-nd';
	}
    return winning ? 'esito-v' : 'esito-p';
}

function EventsList(props) {
    const [widgetContext] = useWidgetContext('#br_widget');
    return (
        <WidgetContext.Provider value={widgetContext}>
            {props.events.map((event, i) => {
                const isBrWidgetS5 = brWidgetS5Enabled(event.sportRef,event.widgetType);
                const isBetgeniusWidget = bgWidgetEnabled(event.sportRef,event.widgetType,event.geniusId);
                const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType,event.lsportWidgetId);
                const flashbetWidgetUrl = getFlashbetWidgetUrl(event.widgetType);
                return (
                    <React.Fragment key={event.id +"_" +i}>
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-column margine-su-giu">
                                <EventInfo isPsv={props.isPsv} event={event} isSystem={props.isSystem} />
                                {!props.isPsv && widgetContext.widgetMatchId != null && widgetContext.widgetMatchId === event.id &&
                                    (flashbetWidgetUrl ?
                                        <FlashbetWidget url={flashbetWidgetUrl}/>
                                        :
                                        isBetgeniusWidget ?
                                            <BetGeniusWidget url={getBetgeniustWidgetUrl(event.sportRef, event.categoryRef, event.tournamentRef)} />
                                        :
                                        isStatsCoreWidget ?
                                            <StatsCoreWidget />
                                        :
                                        <div id={"br_widget_checkbet_" + event.ticketRef + '_' + event.id} className={`betradar-widget sr-widget sr-widget-level-0 sr-widgets-lmts sr-size-small sr480 ${isBrWidgetS5 ? 'brWidgetS5' : ''}`} data-sr-lang="it" data-sr-handle="16"></div>
                                    )
                                }
                                {event.bets.map((bet,i) => {
                                    return (
                                        <div key={bet.id + "_" + bet.drawCode + "_" +i} className="grey-box d-flex margine-su-giu">
                                            <div className="d-flex margine-su-giu">
                                                <span className="text-medium">{bet.desc}:&nbsp;</span>
                                                <span className="text-medium bold">{bet.drawDesc}</span>
                                            </div>
                                             &nbsp;
                                            {
                                            	!props.isBetBuilder && <div className="d-flex margine-su-giu">
                                                	<span className="text-medium">{getLabel('mybets.quota')}:&nbsp;</span>
                                                	<span className="text-medium bold">{oddToStringCheckbet(bet.odd)}</span>  
                                            	</div>
                                            }
                                           
              
                                            <span className={"d-flex align-items-center bold margin-left-auto margine-dx " + getEsitoClass(event.state, bet.isWinning, bet.winningDrawCode)}></span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/*i === (props.events.length - 1) &&
                            <hr />
                        */}
                    </React.Fragment>
                );
			})}
        </WidgetContext.Provider>
    );
}

export default EventsList;